export enum SpotActiveTab {
  Zabrane,
  Brendovi,
  Fonogrami,
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/spotovi/active-tab.enum.ts